export const commaSeprator = (num: number) => {
  if (num === null || num === undefined) {
    throw new Error("Input cannot be null or undefined");
  }
  return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
